import { render, staticRenderFns } from "./AppVersion.vue?vue&type=template&id=609e63b4&scoped=true"
import script from "./AppVersion.vue?vue&type=script&lang=js"
export * from "./AppVersion.vue?vue&type=script&lang=js"
import style0 from "./AppVersion.vue?vue&type=style&index=0&id=609e63b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609e63b4",
  null
  
)

export default component.exports